import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';

import { bookiesActions } from './actions';
import {
  BOOKIES_FAILURE,
  BOOKIES_REQUEST,
  BOOKIES_SUCCESS,
} from '../../constants/bookies';
export interface Bookie {
  id: 'string';
  code: 'string';
  name: 'string';
  logo_url: {
    ios: 'string';
    android: 'string';
    web: 'string';
  };
  url: 'string';
  is_active: boolean;
}
export type BookiesState = {
  requested: boolean;
  data: { bookies: Bookie[] };
  isLoading: boolean;
  error: string | null;
};
export type BookiesActions = ActionType<typeof bookiesActions>;

export const bookiesReducer = combineReducers<BookiesState, BookiesActions>({
  requested: (state = false, action) => {
    switch (action.type) {
      case BOOKIES_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (state = { bookies: [] }, action) => {
    switch (action.type) {
      case BOOKIES_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case BOOKIES_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case BOOKIES_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
